export default __webpack_public_path__ + "static/media/img-api-cat-experience-front.8eca8597.png";